/* @import '../../global/app.css'; */
/* @import '../../global/min-app.css'; */

:host {
  @apply selection:text-dark-blue selection:bg-logo-orange font-poppins;
  display: block;
}

.share-block-wrapper {
  @apply max-w-[650px] lg:min-w-[650px] mx-auto;
}

.article-share-btn {
  @apply block px-16px py-8px text-0 md:text-1 font-medium rounded text-white transition-colors bg-medium-blue hover:bg-dark-blue visited:text-white hover:text-white text-center w-fit; 
}

.addtoany_shortcode .addtoany_list {
  @apply flex justify-center items-center gap-8px flex-nowrap;

}

.addtoany_list a {
  @apply w-32px h-32px bg-medium-blue rounded-[4px] flex flex-row justify-center items-center !important;
  transition: all 0.15s ease;
}

.addtoany_list a:hover {
  @apply opacity-100 bg-dark-blue !important;
}

.addtoany_list a span {
  @apply bg-medium-blue rounded-[4px] !important;
  transition: all 0.15s ease;
}

.addtoany_list a:hover span {
  @apply opacity-100 bg-dark-blue !important;
}
